import Counter from '../Counter';
import Icon from '../Icon';

const Demo6Statistic2 = () => {
    return (
        <section id="statistic-2" className="wide-100 statistic-section division">
            <div className="container">
                <div className="row d-flex align-items-center">
                    <div className="col-lg-6">
                        <div className="txt-block right-column wow fadeInLeft">
                            <h3 className="h3-xs">More than 1,000 teams are already managing their translations with Rush Studio</h3>
                        </div>
                    </div>
                    <div className="col-sm-5 col-md-4 col-lg-3 offset-sm-1 offset-md-2 offset-lg-1">
                        <div className="statistic-block wow fadeInUp">
                            <h2 className="h2-title-xs statistic-number">
                                <Counter end={65} />k
                            </h2>
                            <p className="p-lg mt-20">Projects Delivered <br /> successfully</p>
                        </div>
                    </div>
                    <div className="col-sm-5 col-md-4 col-lg-2">
                        <div className="statistic-block wow fadeInUp">
                            <h2 className="h2-title-xs statistic-number">
                                <Counter end={4.86} decimals={2} />
                            </h2>
                            <div className="txt-block-rating ico-15 yellow-color rating-stars" aria-label="Rated 4.5 out of 5">
                                {[...Array(4)].map((_, index) => (
                                    <Icon key={`full-${index}`} symbol="★" decorative className="icon-star" />
                                ))}
                                <Icon symbol="½" decorative className="icon-star" />
                            </div>
                            <p className="p-lg txt-400">Trusted Ratings</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Demo6Statistic2;
